<template>
  <div id="app" :class="deviceClass">
    <Header v-if="$route.name !== 'Embed' && $route.name !== 'EmbedNoTitle' && $route.name !== 'EmbedWebStats'" />
    <router-view :class="$store.state.i18n.lang" />
    <Footer v-if="$route.name !== 'Embed' && $route.name !== 'EmbedNoTitle' && $route.name !== 'EmbedWebStats'" />
  </div>
</template>

<!-- EMBED EXAMPLE -->
<!-- <iframe
  width="500"
  height="500"
  src="http://localhost:8080/ca/embed/estad%C3%ADstiques/pps29vftxa?view=chart&chart=pie-chart&diff=AwUgrAQqYCILwBMCWBbApgOwM5IPbYDJoIBGceEgsyaeZdbPQ608uSgJnCnO9sVSYc%2BLAS41ekahTHdpAOiQIBKTnPLyATrgA2aOADMkOgC5pNo8a1jyAbgEMdAVzRY%2BGh8-07cAY2CyUh6OLm4SNiYAngAO%2BgCyThhIvkjRSIHWMHYhru42SBgIaAAecAFWCgVFpZQAzHkwDSpCTKL14Y1BsHAcBO2Zisr0vf0K2npw2gDubeo2nqEN2V5wAKJY0fYYkfZ9c1kLuR2KhSVle10HOWEDh3AASq4m9iAcwACqSSAAwvUQ9W9Vk5tLFdqNgl4bpVTjULrdrtxxFcVo8sM9XsAijoMSgfn9ahg4QpDjckSdqj0iRDFpB2siXHAAHK4DG%2BETPKnzBG0jRVM61TlZPmlXoAFia9BaIgI4sucFFBDADQlgkY0qVHX28sV%2B0GKhIAH0orEdZctLp9MbXKb4ZClncEkkUmkbcTuTwIjF4olkql0hrbTSPUKYecA267ccdPYAEZoHQAFS9cEdvpd4d5odFQA&ccfg=MYewdgZglg5gdAFyggNgUzgNwIYoK5oC8AZKJLHCiMLhjvkTQLQCiAyqeNPADJoxowAEwBCaABbZMUEACc4AZ3EgA7nwHCsuAoQi4FaI"
/> -->

<script>
import device from '@/utils/device'
import ResponsiveCss from './mixins/ResponsiveCss'
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import Vue from 'vue'
import { getTypesOfContent } from '@/services/api'

// set up the reactive global object
const global = new Vue({ data: { data: [] } })

// make a plugin to add it to Vue
const GlobalPlugin = {
  install(Vue) {
    Vue.prototype.$getTypesOfContent = global
  },
}

Vue.use(GlobalPlugin)

export default {
  components: { Header, Footer },
  mixins: [ResponsiveCss],
  metaInfo (){
    return {
      title: this.$t('cover_title'),
      titleTemplate: '%s | Ajuntament de Barcelona',
      meta: [
      {
          name: 'title',
          content: this.$t('cover_title')
        },
        {
          name: 'description',
          content: this.$t('meta_description')
        },
        {
          name: 'keywords',
          content: this.$t('meta_keywords')
        },
        {
          property: 'og:description',
          content: this.$t('meta_description')
        },
        {
          property: 'twitter:description',
          content: this.$t('meta_description')
        }
      ]
    }
  },
  asyncComputed: {
    typesOfContent() {
      return getTypesOfContent(this.$store.state.i18n.lang)
    },
  },
  computed: {
    computedTypes() {
      return this.typesOfContent
    },
    deviceClass() {
      return device
    },
  },
  watch: {
    computedTypes() {
      this.$getTypesOfContent.data = this.computedTypes.data
      this.updateHeaderButtons()
    },
    // ALGO ASI se podria hacer, pero menudo lio con los "computedTypes"...
    '$route':{
      handler(){
        this.updateHeaderButtons()
      },
      immediate: true
    }
  },
  mounted(){
    if(this.$route.name !== 'Embed' && this.$route.name !== 'EmbedNoTitle' && this.$route.name !== 'EmbedWebStats'){
      window.bcn.lang = this.$store.state.i18n.lang,
      window.bcn.brandInjection({
        version: 'v2017',
        urls: {
          ca: 'https://www.barcelona.cat/brand/banner/ca/portaldades.html',
          es: 'https://www.barcelona.cat/brand/banner/es/portaldades.html',
          en: 'https://www.barcelona.cat/brand/banner/en/portaldades.html',
        },
        keys: ['UA-171794815-35'],
        callback: () => {
          this.updateHeaderButtons()
        },
      })
    }
  },
  methods:{
    updateHeaderButtons(){
      if(!this.computedTypes?.data) return
      let currType = this.$route.params.type
      let type = this.computedTypes.data.find((t)=>Object.values(t.label).find((k)=>k===currType))

      const langs = ['ca','es','en']
      langs.forEach((lang)=>{
        let route = this.$router.resolve(this.$route.fullPath).resolved
        route.params.type = type?.label[lang]
        route.params.lang = lang
        route = this.$router.resolve(route).resolved
        let href = decodeURIComponent(route.fullPath)//.replace(currType,type?.label[lang]).replace(this.$store.state.i18n.lang,lang)
        document
          .querySelectorAll(`[data-ga=${lang.toUpperCase()}]`)
          .forEach(n => n.setAttribute('href', href))
      })
    }
  }
}
</script>

<style lang="stylus">
@import "./styles/main"

#brand
  position: inherit
  
#app
  background-color: $bcn-background-grey
  display: flex
  flex-direction: column
  min-height: 100vh

  .body
    display: flex
    flex: 1 1 0%
    flex-direction: column
    position: relative

.vm--modal
  .mobile &
    height: 95vh !important
    left: 50% !important
    top: 50% !important
    transform: translate(-50%, -50%) !important
    width: 90vw !important

.vm--container
  margin: 0 !important
</style>
